<template>
  <section class="section__banks">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="9" lg="10" class="section__banks-data px-5">
          <AccountingSystem
            :headers="headers"
            :items="getorgpostList"
            v-on:getItem="getData"
            v-on:getListBySearch="getSearch"
            v-on:getList="getPage"
            :insertItemData="addData"
            :editItemData="editData"
            :removeItemData="removeData"
            :hasAttachment="false"
            :hasPayment="false"
            :hasSupplement="false"
            :hasAction="false"
            :hasContacts="false"
            add="true"
            edit="true"
            remove="true"
          >
            <template v-slot:addForm>
              <v-form ref="formAdd">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        :rules="requiredRule"
                        label="پست سازمانی"
                        outlined
                        dense
                        hide-details
                        v-model="addData.orgPostTitle"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :rules="requiredRule"
                        label="واحد سازمانی"
                        outlined
                        :items="getorgunitList.records"
                        item-text="orgUnitTitle"
                        item-value="orgUnitId"
                        dense
                        hide-details
                        v-model="addData.orgUnitFk"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        label="فعال"
                        v-model="addData.isActive"
                        dense
                        hide-details
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </template>
            <template v-slot:editForm>
              <v-form ref="formEdit">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        :rules="requiredRule"
                        label="پست سازمانی"
                        outlined
                        dense
                        hide-details
                        v-model="editData.data.orgPostTitle"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :rules="requiredRule"
                        label="واحد سازمانی"
                        outlined
                        :items="getorgunitList.records"
                        item-text="orgUnitTitle"
                        item-value="orgUnitId"
                        dense
                        hide-details
                        v-model="editData.data.orgUnitFk"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        label="فعال"
                        v-model="editData.data.isActive"
                        dense
                        hide-details
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-form>
            </template>
          </AccountingSystem>
        </v-col>
        <v-col cols="12" md="3" lg="2" class="section__banks-sidbar">
          <MenuLeft></MenuLeft>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import MenuLeft from "../../components/MenuLeft.vue";
import AccountingSystem from "../../components/AccountingSystem.vue";
import { mapGetters } from "vuex";
import { myMixin } from "../../../mixins.js";
import axios from "axios";
export default {
  name: "Banks",
  mixins: [myMixin],
  components: {
    MenuLeft,
    AccountingSystem,
  },
  data() {
    return {
      searchTest: "",
      addData: {
        url: "orgpost/create/",
        formName: "formAdd",
        orgPostTitle: null,
        orgUnitFk: null,
        isActive: true,
      },
      editData: {
        url: "orgpost/update/",
        formName: "formEdit",
        data: {
          orgPostTitle: null,
          orgUnitFk: null,
          isActive: true,
        },
      },
      removeData: { url: "orgpost/delete/" },
      headers: [
        {
          text: "عنوان پست سازمانی",
          align: "center",
          value: "orgPostTitle",
        },
        {
          text: "واحد سازمانی",
          align: "center",
          value: "orgUnitFk",
        },
        {
          text: "فعال",
          align: "center",
          value: "isActive",
        },
        { text: "", value: "actions", align: "left", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["getorgpostList", "getorgunitList", "getUrl"]),
  },
  created() {
    this.getorgunit();
    this.getorgpost();
  },
  methods: {
    getSearch(search) {
      this.searchTest = search;
      this.$store.dispatch("sendList", {
        url: "orgpost/list/",
        page: 1,
        phrase: search,
      });
    },
    getPage(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$store.dispatch("sendList", {
        url: "orgpost/list/",
        page: item,
        Phrase: this.searchTest,
      });
    },
    getorgpost() {
      this.$store.dispatch("sendList", {
        url: "orgpost/list/",
        page: 1,
        Phrase: "",
      });
    },
    getorgunit() {
      this.$store.dispatch("sendList", {
        url: "orgunit/list/",
        page: 1,
        count: -1,
        phrase: "",
      });
    },
    getData(item) {
      // console.log(item, "----------------");
      axios
        .get(`${this.getUrl}/orgpost/get/`, {
          params: {
            Id: item.orgPostId,
            Language: 0,
          },
        })
        .then((response) => {
          // console.log(response, "==============");
          this.editData.data = response.data.record;
          this.editData.data.test = this.$refs;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.section__banks {
  background-color: #eeeeee !important;
}
</style>
